import { success, error, abort } from "@redux-requests/core";
import * as TYPES from "./Profile.types";
import {removeToken,getFlag} from "../../../utils";
import Toast from "../../../components/Common/Toast";
import ToastMessage from "../../../components/Common/ToastMessage";

const initialState = {
  loading: false,
  firstName: '',
  secondName: '',
  email: '',
  about: null,
  publicUrlName: null,
  avatar: null,
  stripeAccountErrors: null,
  stripeAccountLink: '',
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPES.GET_PROFILE_INFO:
    case TYPES.SETUP_PROFILE_URL:
    case TYPES.SETUP_PROFILE: {
      return {
        ...state,
        loading: true,
      };
    }
    case success(TYPES.SETUP_PROFILE): {
      if(action.response.data.message) {
        if(getFlag()==="true" || getFlag() ===true){
          console.log('Setup Profile')
        }
        else
        {
          console.log('Edit Profile Profile')
          Toast(`${action.response.data.message}`, "success")
        }
       
      }
      return {
        ...state,
        firstName: action.response.data.firstName,
        secondName: action.response.data.secondName,
        about: action.response.data.about,
        avatar: action.response.data.avatar,
        loading: false,
      };
    }
    case TYPES.ON_LOGOUT: {
      return {
        ...state,
        ...initialState,
      };
    }
    case success(TYPES.SETUP_PROFILE_URL): {
      return {
        ...state,
        publicUrlName: action.response.data.publicUrlName,
        loading: false,
      };
    }
    case success(TYPES.GET_PROFILE_INFO): {
      return {
        ...state, ...action.response.data, loading: false,
      };
    }
    case abort(TYPES.GET_PROFILE_INFO): {
      return {
        ...state,
        loading: false,
      };
    }
    case error(TYPES.GET_PROFILE_INFO): {
      removeToken();
      return {
        ...state,
        loading: false,
      };
    }
    case abort(TYPES.SETUP_PROFILE_URL):
    case abort(TYPES.SETUP_PROFILE):
    case error(TYPES.SETUP_PROFILE_URL):
    case error(TYPES.SETUP_PROFILE): {
      Toast(ToastMessage(11), "error")
      return {
        ...state,
        loading: true,
      };
    };
    default:
      return state;
  }
};

export default reducer;
